import { usePage } from "@/components/page/PageContext";
import { MarketDemand } from "@/components/retail/MarketDemand";
import StoreList from "@/pages/retail/StoreList";
import { getRetailReport } from "@/queries/retail";
import { useReportContext } from "@/stores/ReportContext";
import { useSessionData } from "@/stores/SessionDataContext";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

function LoadingState() {
  return (
    <div className="w-full h-full flex items-center justify-center py-12">
      <div className="flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
        <div className="text-slate-400">
          Loading data. Please wait a moment...
        </div>
      </div>
    </div>
  );
}

function MarketDemandPage() {
  const { restrict_store, stores } = useSessionData();

  const { reportId } = useReportContext();
  const singleStore = !!restrict_store;
  const { store } = useParams();
  const { setTitles } = usePage();

  useEffect(() => {
    setTitles(["Market Demand"]);
  }, [setTitles]);

  const storeId = store ? parseInt(store) : null;
  const currentStores = singleStore
    ? []
    : storeId
      ? [storeId]
      : stores.map((s) => s.id);

  // Query for current view
  // No store in the URL means the "All Stores" view. Sent explicitly because a
  // single-store brand's store list is identical either way.
  const allStores = !singleStore && storeId === null;

  const { isLoading, isFetching, error, data } = getRetailReport.useQuery({
    report: Number(reportId),
    stores: currentStores,
    allStores,
  });

  // Only show full-page loading state for initial hard load
  if (isLoading) {
    return (
      <div className="flex flex-col h-full">
        {!singleStore && <StoreList />}
        <LoadingState />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col h-full">
        {!singleStore && <StoreList />}
        <div className="text-red-500 p-8">
          Error loading data: {error.message}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full">
      {!singleStore && <StoreList />}
      <div className={"flex-1 px-4 md:px-8 py-4"}>
        {isFetching ? (
          <LoadingState />
        ) : data?.markets && data.markets.length > 0 ? (
          <MarketDemand data={data.markets} storeId={storeId} />
        ) : (
          <div className="flex flex-col items-center justify-center py-24 text-slate-500">
            <svg className="w-12 h-12 mb-4 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
            <p className="text-sm">Market Demand is not enabled for this airport.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default MarketDemandPage;
